import { setViewportUnits, PlayVideoInViewportOnly, EditableSvg, scrollToHash } from './utils/utilities.js';
import { Offcanvas } from './global/offcanvas';
import { Header } from './global/header';
import { DropdownMenu } from './global/dropdownMenu';
import { scrollToTop } from './global/scroll-to-top.js';
import { Stats } from './blocks/stats.js';
import { DownArrow } from './blocks/down-arrow.js';
import { Accordion } from './blocks/accordion.js';

document.addEventListener('DOMContentLoaded', () => {
    setViewportUnits();

    scrollToHash();

    Array.from(document.querySelectorAll('.editable-svg')).map((img) => EditableSvg(img));

    // stop autoplay video when out of viewport
    Array.from(document.querySelectorAll('video[autoplay]')).map((video) => PlayVideoInViewportOnly(video));

    Header(document.querySelector('.site-header'));

    DropdownMenu();

    const offcanvas = document.querySelector('.offcanvas');
    if (offcanvas) {
        new Offcanvas(offcanvas);
    }

    scrollToTop();

    // blocks
    Stats();
    DownArrow();
    Accordion();
});

import.meta.glob([
    '../../images/**',
    '!../../images/cms/**',
    '../../fonts/**',
]);
